import sortSearch from './sortSearchClient';

const findOrder = (
  _a,
  _b,
  rates_a,
  rates_b,
  provider_priority_a = 0,
  provider_priority_b = 0
) => {
  const providerDiff = provider_priority_a - provider_priority_b;

  if (providerDiff !== 0) {
    return providerDiff;
  }

  const priceA =
    Number.parseFloat(rates_a?.price?.details_USD?.total) || Infinity;
  const priceB =
    Number.parseFloat(rates_b?.price?.details_USD?.total) || Infinity;

  const diff = priceA - priceB;

  return diff;
};

export default function sortHotelsClient(hotels, providers_priority) {
  return sortSearch(hotels, findOrder, providers_priority);
}
